import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const userToken = () => localStorage.getItem("ovamx:user_token") || "";
const authHeaders = () => {
  const t = userToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const travelApi = {
  // Destinations
  listPlaces: async (params = {}) => {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined) sp.set(k, v);
    });
    const r = await axios.get(`${API}/travel/places?${sp.toString()}`);
    return r.data || [];
  },
  getPlace: async (pid) => {
    const r = await axios.get(`${API}/travel/places/${pid}`);
    return r.data;
  },
  experiencesByPlace: async (pid) => {
    const r = await axios.get(`${API}/travel/places/${pid}/experiences`, { headers: authHeaders() });
    return r.data || [];
  },
  // Cultural AI
  askCultural: async (pid, question, sessionId = null) => {
    const r = await axios.post(
      `${API}/travel/places/${pid}/ask`,
      { question, session_id: sessionId },
      { headers: authHeaders() }
    );
    return r.data; // { session_id, answer, place_id }
  },
  // Experiences (community)
  listExperiences: async (params = {}) => {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined) sp.set(k, v);
    });
    const r = await axios.get(`${API}/travel/experiences?${sp.toString()}`, { headers: authHeaders() });
    return r.data || [];
  },
  createExperience: async (payload) => {
    const r = await axios.post(`${API}/travel/experiences`, payload, { headers: authHeaders() });
    return r.data;
  },
  deleteExperience: async (eid) => {
    const r = await axios.delete(`${API}/travel/experiences/${eid}`, { headers: authHeaders() });
    return r.data;
  },
  toggleLike: async (eid) => {
    const r = await axios.post(`${API}/travel/experiences/${eid}/like`, {}, { headers: authHeaders() });
    return r.data;
  },
  listComments: async (eid) => {
    const r = await axios.get(`${API}/travel/experiences/${eid}/comments`);
    return r.data || [];
  },
  addComment: async (eid, body) => {
    const r = await axios.post(`${API}/travel/experiences/${eid}/comments`, { body }, { headers: authHeaders() });
    return r.data;
  },
  // Trip Planner
  listPlans: async () => {
    const r = await axios.get(`${API}/plans`, { headers: authHeaders() });
    return r.data || [];
  },
  createPlan: async (payload) => {
    const r = await axios.post(`${API}/plans`, payload, { headers: authHeaders() });
    return r.data;
  },
  deletePlan: async (planId) => {
    const r = await axios.delete(`${API}/plans/${planId}`, { headers: authHeaders() });
    return r.data;
  },
  listPlanItems: async (planId) => {
    const r = await axios.get(`${API}/plans/${planId}/items`, { headers: authHeaders() });
    return r.data || [];
  },
  createPlanItem: async (planId, payload) => {
    const r = await axios.post(`${API}/plans/${planId}/items`, payload, { headers: authHeaders() });
    return r.data;
  },
  deletePlanItem: async (planId, itemId) => {
    const r = await axios.delete(`${API}/plans/${planId}/items/${itemId}`, { headers: authHeaders() });
    return r.data;
  },
  updatePlanItem: async (planId, itemId, patch) => {
    const r = await axios.patch(`${API}/plans/${planId}/items/${itemId}`, patch, { headers: authHeaders() });
    return r.data;
  },
  reorderPlanItems: async (planId, dayDate, itemIds) => {
    const r = await axios.post(
      `${API}/plans/${planId}/items/reorder`,
      { day_date: dayDate, item_ids: itemIds },
      { headers: authHeaders() },
    );
    return r.data;
  },
  planAiSuggest: async (planId) => {
    const r = await axios.post(`${API}/plans/${planId}/ai-suggest`, {}, { headers: authHeaders() });
    return r.data; // { suggestions: [{day_date, time, kind, title, ...}] }
  },
};

export const PLACE_CATEGORIES = [
  { id: "", label: "Todos" },
  { id: "city", label: "Ciudades" },
  { id: "landmark", label: "Monumentos" },
  { id: "beach", label: "Playas" },
  { id: "mountain", label: "Montañas" },
  { id: "park", label: "Parques" },
];
